import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'

export default function TooltipForDisabledComponent({
  children,
  'data-testid': dataTestId,
  ...props
}) {
  return (
    <Tooltip {...props}>
      <div data-testid={dataTestId}>{children}</div>
    </Tooltip>
  )
}

TooltipForDisabledComponent.propTypes = {
  'data-testid': PropTypes.string,
}
